import { createSlice } from '@reduxjs/toolkit'

const initialState = {

}

const statusCodeSlice = createSlice({
  name: 'statusCode',
  initialState,
  reducers: {
    setStatusCode: (state, action) => {
      Object.keys(action.payload).forEach(key => {
        state[key] = action.payload[key]
      })
    }
  }
})

export const { setStatusCode } = statusCodeSlice.actions
export default statusCodeSlice.reducer
